import { withInstall } from '@vuesax-plus/utils'
import AvatarGroup from './src/avatar-group.vue'

export const VsAvatarGroup = withInstall(AvatarGroup)
export default VsAvatarGroup

export * from './src/avatar-group'
